<template>
  <div>
    <div v-show="showChart"><canvas id="boxplot"></canvas></div>
    <div v-show="!showChart" class="mt-10">Tidak ada data tersedia</div>
  </div>
</template>
<script>
import { Chart, registerables } from 'chart.js'
import { BoxPlotController, BoxAndWiskers } from '@sgratzl/chartjs-chart-boxplot'
import zoomPlugin from 'chartjs-plugin-zoom'

Chart.register(...registerables, BoxPlotController, BoxAndWiskers, zoomPlugin)

const boxplotData = {
  labels: [],
  datasets: [
    {
      maxBarThickness: 30,
      label: '',
      backgroundColor: 'rgba(255,0,0,0.5)',
      borderColor: 'red',
      borderWidth: 1,
      outlierColor: '#fff700',
      padding: 10,
      itemRadius: 0,
      data: [],
    },
  ],
}

export default {
  props: {
    chartData: {},
  },
  data() {
    return {
      chartView: '',
      showChart: false,
    }
  },
  watch: {
    chartData: {
      handler(newVal, oldVal) {
        if (newVal.titik_ukur.length > 0) {
          this.showChart = true
        } else {
          this.showChart = false
        }
        let max = -1
        let min = 999999999
        this.chartView.data.labels = []
        this.chartView.data.datasets.forEach((dataset) => {
          dataset.data = []
        })
        newVal.titik_ukur.forEach((row) => {
          this.chartView.data.labels.push(row.tanggal)
          var nilai_titik_ukur = []
          row.titik_ukur.forEach((n) => {
            nilai_titik_ukur.push(n.nilai_titik_ukur)
            if (n.nilai_titik_ukur > max) {
              max = n.nilai_titik_ukur
            }
            if (n.nilai_titik_ukur < min) {
              min = n.nilai_titik_ukur
            }
          })

          this.chartView.data.datasets.forEach((dataset) => {
            dataset.data.push(nilai_titik_ukur)
          })
        })
        this.chartView.options.scales.y.max = parseInt(max) + 10
        this.chartView.options.scales.y.min = parseInt(min) - 10
        this.chartView.update()
      },
      deep: true,
    },
  },
  mounted() {
    const canvas = document.getElementById('boxplot')
    const ctx = document.getElementById('boxplot').getContext('2d')
    this.chartView = new Chart(ctx, {
      type: 'boxplot',
      data: boxplotData,
      options: {
        responsive: true,
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true,
              },
              mode: 'xy',
            },
          },
          legend: {
            display: false,
          },
        },
        title: {
          display: false,
          text: 'Chart.js Box Plot Chartx',
        },
      },
    })

    canvas.onclick = (evt) => {
      const res = this.chartView.getElementsAtEventForMode(
        evt,
        'nearest',
        { intersect: true },
        true
      )
      if (res.length === 0) {
        return
      }
      //alert('You clicked on ' + this.chartView.data.labels[res[0].index])
      this.$emit('tanggal', this.chartView.data.labels[res[0].index])
    }
  },
}
</script>
